export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el entradas');

    //let href = $('.btn-entradas-ciudad').attr('href');

    let href = 'https://tickets.musicalgrease.es/espectaculo/grease-el-musical/GR01';

    $('.btnEntradas').attr('href', href);

   
    $('.popupFamilias').animate({
        'opacity' : '1',
        'height' : '100%',
        'top' : 0,
        'left': 0,
        'width' : '100%',
      }, 1000);

    function cerrarPopUp () {
      $('.popupFamilias').animate({
        'opacity' : '0',
        'height' : '0',
        'top' : '-100vh',
        'left': '-100vw',
        'width' : '0',
      }, 500);
    }

    $('#cerrar').on('click',function(){
      cerrarPopUp ();
    });

    setTimeout(function() {
      var ventana_ancho = $(window).width();
      if (ventana_ancho < 980) {
        cerrarPopUp ();
      }
    }, 5000)


    let miVariable = location.hash;

    let idDiv = '';
    if( (miVariable != '') && (miVariable != undefined)) {
      idDiv = '#viaje-cont';
      
    } else {
      idDiv = '';
    }
    
    const miUrl = '#viaje-cont';
    $('.btn-entradas-viaje').attr('href', miUrl);


    // let prevUrl = document.referrer;

    // console.log('esta es la url  ' + prevUrl);
    // console.log(document.URL);



    // if(prevUrl != document.URL) {
    //   var $target = '#viaje-cont';
    //   $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
    //   if ($target.length) {
    //     console.log('paso 2 ' + $target.offset().top);
    //     var targetOffset = $target.offset().top - 300;
    //     console.log('sigue ' + targetOffset);
    //     $('html,body').animate({scrollTop: targetOffset}, 800);
    //     return false;
    //   }
    // }

    if(idDiv != '') {
      var coordenadas = $(idDiv).position();
      
      $('html,body').animate({scrollTop: (coordenadas.top - 300)}, 100); 
     // location.pathname = document.URL;
    

    }
   
  
   

    

    $('a[href*=#]').on('click',function() {
     
     
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
      && location.hostname == this.hostname) {
        var $target = $(this.hash);
        $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
        if ($target.length) {
          
          var targetOffset = $target.offset().top - 300;
          
          $('html,body').animate({scrollTop: targetOffset}, 800);
          return false;
        }
      }
    });


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-entradas.js